import angular from "angular"
import "angular-ui-router"

export default angular.module("homeModule", ["ui.router"])